import { MasterConfigPage } from '../master/MasterConfigPage';

export function ConfiguracoesPage() {
  return <MasterConfigPage />;
}
